import React from "react";
import ReactModal from "react-modal";
import PropTypes from "prop-types";

import ScreenWidth from "components/hoc/ScreenWidth";

const Modal = ({
  children,
  isFullscreenMobile,
  isLoading,
  isMobile,
  isOpen,
  margin,
  onClose,
  width,
}) => {
  const style = {
    content: {
      background: "#FFF",
      border: 0,
      borderRadius: ".5rem",
      boxShadow: !isMobile && "0 0 0 1px rgba(145,166,182,0.08), 0 2px 10px 0 rgba(0,0,0,0.10)",
      margin: `${margin}% auto`,
      maxWidth: `${width}px`,
      padding: 0,
      position: "initial",
      overflow: "none",
      ...(isMobile &&
        isFullscreenMobile && {
          margin: 0,
          borderRadius: 0,
          maxWidth: "100%",
          minHeight: "100%",
        }),
    },
    overlay: {
      backgroundColor: isMobile && isFullscreenMobile ? "#FFF" : "rgba(40, 47, 56, 0.75)",
      zIndex: 2000,
      overflow: "auto",
      overflowX: "hidden",
      padding: isMobile && isFullscreenMobile ? 0 : "0 20px 20px",
      position: isMobile && isFullscreenMobile ? "absolute" : "fixed",
    },
  };

  ReactModal.setAppElement("body");

  if (!isOpen) return null;

  return (
    <ReactModal
      closeTimeoutMS={200}
      contentLabel="Modal"
      onRequestClose={() => !isLoading && onClose && onClose()}
      style={style}
      isOpen
    >
      {children}
    </ReactModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  margin: PropTypes.number,
  width: PropTypes.number,
  isFullscreenMobile: PropTypes.bool,
  isMobile: PropTypes.bool,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
  isFullscreenMobile: true,
  margin: 3,
  width: 560,
};

export default ScreenWidth(Modal);
